<div class="type-selection-new-contract">
  <div class="type-selection-new-contract__header">
    <h2 class="type-selection-new-contract__title">{{ 'NEW_CONTRACTS.USER.TITLE' | i18nextEager }}</h2>
  </div>
  <section>
    <h2>{{ 'NEW_CONTRACTS.MULTIPOINT.TITLE' | i18nextEager }}</h2>
    <form [formGroup]="typeDataForm">
      <mat-radio-group
        aria-labelledby=""
        class="type_options"
        formControlName="type_option"
        (change)="onChangeTypeOption($event)"
      >
        <mat-radio-button value="0">
          <span class="bold">{{ 'NEW_CONTRACTS.MULTIPOINT.ONE_POINT' | i18nextEager }}</span>
        </mat-radio-button>
        <mat-radio-button value="1">
          <span class="bold">{{ 'NEW_CONTRACTS.MULTIPOINT.MULTI_POINT' | i18nextEager }}</span>
        </mat-radio-button>
      </mat-radio-group>
    </form>
  </section>
</div>
